// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1tfW5","loaderOuter":"PageOverlayLoader_loaderOuter__346Wc"};